const LABEL_COPY = {
  a: 'an XlSheet',
  b: 'a Doc',
  c: 'an APP',
}

export function formatAgentQuestionAnswerCopy(answer) {
  if (!answer) return ''
  const target = LABEL_COPY[answer.optionId] || answer.freeText || answer.sendText
  return `Sounds good — we'll create ${target}.`
}
